import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import WebArPlayer from './WebArPlayer';

const lensPublicUrls = [process.env.LPU_1, process.env.LPU_2, process.env.LPU_3];
const lensDeepLinks = [process.env.LDL_1, process.env.LDL_2, process.env.LDL_3];
const title = process.env.TITLE;

function App() {
  
  useEffect(() => {
    document.title = title!;
  }, [title]);

  return (
    <Router>
      <Routes>
        <Route path="/aoilca" element={<WebArPlayer lensId={0} lensPublicUrl={lensPublicUrls[0]!} lensDeepLink={lensDeepLinks[0]!}/>} />
        <Route path="/chfwus" element={<WebArPlayer lensId={1} lensPublicUrl={lensPublicUrls[1]!} lensDeepLink={lensDeepLinks[1]!}/>} />
        <Route path="/tqbroy" element={<WebArPlayer lensId={2} lensPublicUrl={lensPublicUrls[2]!} lensDeepLink={lensDeepLinks[2]!}/>} />
      </Routes>
    </Router>
  );
}

export default App;